import { Box } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Tab from "@mui/material/Tab";
import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../components/Header";
import OrionToggleButton from "../../../components/OrionToggleButton";
import HostsOnlineGrid from "./status-components/hostsOnlineGrid";
import NewDiscoveries from "./status-components/NewDiscoveries";

// Same reseller/user branch this file already distinguishes above for the "type" check.
const ASSET_DETAIL_PATH = window.sessionStorage.getItem("type") === "reseller"
  ? "/reseller/myC/asset-detail"
  : "/user/network-status/asset-detail";

const Status = ({ customerName }) => {

  if (!customerName && window.sessionStorage.getItem("type") === "reseller") {
    window.sessionStorage.setItem("selectedTab", "Dashboard");
    setTimeout(function checkCondition() {
      if (window.sessionStorage.getItem("selectedTab") === "Dashboard") {
        window.location.href = `/${window.sessionStorage.getItem("type")}/home`;
      } else {
        setTimeout(checkCondition, 500);
      }
    }, 0);
  }

  const navigate = useNavigate();
  const location = useLocation();
  const [tab, setTab] = useState("inventory");

  // Drill-down filters arriving from the Overview page via query string (this app's
  // existing convention, e.g. scenes/security/critical/index.jsx) — read once on
  // mount, matching HostsOnlineGrid's `initialFilters` prop contract. Overview can
  // now stack multiple dimensions (zone + vlan + ...), so this is a JSON-encoded
  // array rather than a single ffield/fop/fvalue triplet.
  const inventoryFilters = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const raw = params.get("filters");
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
    } catch {
      return null;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOpenAsset = (assetId) => {
    navigate(`${ASSET_DETAIL_PATH}?assetId=${encodeURIComponent(assetId)}`);
  };

  return (
    <Box m="20px">
      <Box display="flex" alignItems="center" gap={1.5}>
        <Header title="Inventory" subtitle=" " />
        <OrionToggleButton />
      </Box>

      <TabContext value={tab}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 1 }}>
          <TabList
            onChange={(_, v) => setTab(v)}
            sx={{
              "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontSize: 13 },
            }}
          >
            <Tab label="Inventory" value="inventory" />
            <Tab label="New Discoveries" value="new-discoveries" />
          </TabList>
        </Box>

        <TabPanel value="inventory" sx={{ p: 0 }}>
          <Box padding="1rem">
            <HostsOnlineGrid initialFilters={inventoryFilters} onOpenAsset={handleOpenAsset} />
          </Box>
        </TabPanel>

        <TabPanel value="new-discoveries" sx={{ p: 0 }}>
          <Box padding="1rem">
            <NewDiscoveries />
          </Box>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default Status;
